import _ from 'lodash';
const helpers = {
    /*!
     * Add items to an object at a specific path
     * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Object}       obj  The object
     * @param  {String|Array} path The path to assign the value to
     * @param  {*}            val  The value to assign
     */
    put: function (obj, path, val) {
        /**
         * If the path is a string, convert it to an array
         * @param  {String|Array} path The path
         * @return {Array}             The path array
         */
        var stringToPath = function (path) {
            // If the path isn't a string, return it
            if (typeof path !== 'string') return path;

            // Create new array
            var output = [];

            // Split to an array with dot notation
            path.split('.').forEach(function (item) {
                // Split to an array with bracket notation
                item.split(/\[([^}]+)\]/g).forEach(function (key) {
                    // Push to the new array
                    if (key.length > 0) {
                        output.push(key);
                    }
                });
            });

            return output;
        };

        // Convert the path to an array if not already
        path = stringToPath(path);

        // Cache the path length and current spot in the object
        var length = path.length;
        var current = obj;

        // Loop through the path
        path.forEach(function (key, index) {
            // If this is the last item in the loop, assign the value
            if (index === length - 1) {
                current[key] = val;
            }

            // Otherwise, update the current place in the object
            else {
                // If the key doesn't exist, create it
                if (!current[key]) {
                    current[key] = {};
                }

                // Update the current place in the objet
                current = current[key];
            }
        });
    },
    stringToPath(path) {
        // If the path isn't a string, return it
        if (typeof path !== 'string') return path;

        // Create new array
        var output = [];

        // Split to an array with dot notation
        path.split('.').forEach(function (item) {
            // Split to an array with bracket notation
            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                // Push to the new array
                if (key.length > 0) {
                    output.push(key);
                }
            });
        });

        return output;
    },
    mergeObj(newObj, obj) {
        // _.has(obj, )
        for (const i in newObj) {
            if (_.has(obj, i)) {
                //nothing for now
                for (const x in newObj[i]) {
                    if (typeof obj[i][x] === 'string') {
                        obj[i][x] = {
                            error: obj[i][x],
                        };
                    }
                    _.merge(obj[i][x], newObj[i][x]);
                }
            } else {
                obj[i] = newObj[i];
            }
        }
        return obj;
    },
    parseErrorObjects(errorObj) {
        let newErrorObj = {};
        for (const errorIndex in errorObj) {
            const tempArray = errorIndex.split('.');
            let tempObj = {};
            for (let i = tempArray.length - 1; i >= 0; i--) {
                if (i === tempArray.length - 1) {
                    //this means that it is the key where we should add the error;
                    tempObj = {
                        [tempArray[i]]: errorObj[errorIndex],
                    };
                } else {
                    if (/\[[\d]+\]/.test(tempArray[i])) {
                        const childKey = tempArray[i].replace(/\[[\d]+\]/, '');
                        let childValue = tempArray[i].match(/\d+/);
                        if (childValue) {
                            childValue = childValue[0];
                            const obj = {
                                [childKey]: {
                                    [childValue]: { ...tempObj },
                                },
                            };
                            tempObj = obj;
                        }
                    } else {
                        const obj = {
                            [tempArray[i]]: { ...tempObj },
                        };
                        tempObj = obj;
                    }
                }
            }
            newErrorObj = this.mergeObj(tempObj, newErrorObj);
        }
        return newErrorObj;
    },
    extractBlockErrors(blockName, responseErrors, wizardErrors) {
        let blockErrors = { ...wizardErrors };
        Object.keys(responseErrors).map((error) => {
            if (error.split('.')[0] === blockName) {
                blockErrors[error] = responseErrors[error];
            }
        });
        return blockErrors;
    },
    extractWizardErrors(responseErrors, wizardErrors, replaceApiPath = true) {
        let parsedErrors = { ...wizardErrors };
        for (const i in responseErrors) {
            if (replaceApiPath) {
                parsedErrors[i.replace('application.applicationBlocks.', '')] =
                    responseErrors[i][0];
            } else {
                parsedErrors[i] = responseErrors[i];
            }
        }
        return parsedErrors;
    },
};

export default helpers;
